import firebase from "@firebase/app";
import 'firebase/firestore'
import 'firebase/database'
import "@firebase/auth";

const config = {
  apiKey: "AIzaSyBst3VmMUELaKP8hZb9ixorrINzjafK1nM",
  authDomain: "uecst-6ad06.firebaseapp.com",
  databaseURL: "https://uecst-6ad06.firebaseio.com",
  projectId: "uecst-6ad06",
  storageBucket: "uecst-6ad06.appspot.com",
  messagingSenderId: "629024880962",
  appId: "1:629024880962:web:e432bba0c8fa4c642eb0db",
  measurementId: "G-339N2KEVXN"
};
var fbapp = firebase.initializeApp(config)
export default {
  fbapp: fbapp,
  getDatabase(){
    return firebase.database(fbapp);
  },
  init() {
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
  }
};
